import './Start.css';

const Start = ({ beginRoute }) => {
  return (
    <div id='start' className='start'>
      <div className='title'>PathSketch</div>
      <div className='button-container'>
        <button className='button-74' type='button' onClick={beginRoute}>Start</button>
      </div>
    </div>
  )
}

export default Start;